import {
  LandingCasesBody,
  type LandingCasesBodyProps,
} from "@/components/landing/cases-body";
import { DEFAULT_CASES } from "@/lib/landing/puck/defaults";
import type { LandingTextValue } from "@/lib/landing/puck/styled-text";

export type LandingCaseItem = {
  id?: string;
  title: LandingTextValue;
  summary?: LandingTextValue;
  pdfUrl?: string | null;
  coverUrl?: string | null;
  reportTypes?: string[];
  industries?: string[];
};

export type LandingCasesProps = {
  sectionId?: string;
  title?: LandingTextValue;
  subtitle?: LandingTextValue;
  backgroundImageUrl?: string;
  backgroundColor?: string;
  source?: "library" | "manual";
  reportTypes?: string[];
  industries?: string[];
  limit?: number;
  layout?: "grid" | "stack" | "carousel";
  pageReportTypes?: string[];
  items?: LandingCaseItem[];
};

/** Секция кейсов — делегирует в клиентский body (карусель / фильтры). */
export function LandingCasesView({
  sectionId = DEFAULT_CASES.sectionId,
  title = DEFAULT_CASES.title,
  subtitle = DEFAULT_CASES.subtitle,
  backgroundImageUrl = DEFAULT_CASES.backgroundImageUrl,
  backgroundColor,
  layout = "grid",
  items = [],
}: LandingCasesProps & { items: LandingCaseItem[] }) {
  const props: LandingCasesBodyProps = {
    sectionId,
    title,
    subtitle,
    backgroundImageUrl,
    backgroundColor,
    layout,
    items,
  };

  return <LandingCasesBody {...props} />;
}
